class PasswordLengthCounter {
    private readonly $documentObject: Document;

    constructor(document: Document) {
        this.$documentObject = document;
    }

    registerEventListeners() {
        const passwordInputField = document.querySelector(".id_js_password_password") as HTMLInputElement;
        passwordInputField!!.addEventListener("input", (ev) => {
            this.onInputEvent(ev.currentTarget as HTMLInputElement);
        });
        passwordInputField!!.addEventListener("focusin", (ev) => {
            this.onFocusIn(ev.currentTarget as HTMLInputElement);
        });
    }

    private onFocusIn(inputField: HTMLInputElement) {
        this.updatePasswordCharCountLabel(inputField);
        this.highlightCounterIfPasswordTooShort(inputField);
    }

    private onInputEvent(inputField: HTMLInputElement) {
        this.updatePasswordCharCountLabel(inputField);
        this.highlightCounterIfPasswordTooShort(inputField);
    }

    private updatePasswordCharCountLabel(passwordField: HTMLInputElement) {
        const charCount = passwordField.value.length;
        const countLabelElement = this.$documentObject.querySelector(".password_char_counter") as HTMLElement;
        const placeHolderText = passwordField.getAttribute("placeholder");

        const textToAppend = (this.$documentObject.querySelector(".password_hint_text_to_append_min") as HTMLElement).innerHTML;
        const textToAppendChar = (this.$documentObject.querySelector(".password_hint_text_to_append_char") as HTMLElement).innerHTML;

        countLabelElement.innerHTML = `${placeHolderText} (<span class="password-counter-formatting">${charCount} ${textToAppendChar} </span>${textToAppend})`;
    }

    private highlightCounterIfPasswordTooShort(passwordField: HTMLInputElement) {
        const charCount = passwordField.value.length;
        const counterSpan = this.$documentObject.querySelector(".password-counter-formatting") as HTMLElement;
        if (counterSpan) {
            if (charCount < 8) {
                counterSpan.classList.add("invalid");
            } else {
                counterSpan.classList.remove("invalid");
            }
        }
    }
}

export default PasswordLengthCounter;
